import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Welcome from "@/pages/Welcome";
import Podcast from "@/pages/Podcast";
import Wynn from "@/pages/Wynn";
import WorkWithMe from "@/pages/WorkWithMe";
import TheDeeperReactivation from "@/pages/TheDeeperReactivation";
import NotFound from "@/pages/NotFound";
import CookieNotice from "@/components/CookieNotice";
import { Toaster } from "@/components/ui/sonner";
import { isWynnHost } from "@/lib/domain";

function App() {
  const wynnOnly = isWynnHost();

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {wynnOnly ? (
            <Route path="*" element={<Wynn />} />
          ) : (
            <>
              <Route path="/" element={<Landing />} />
              <Route path="/welcome" element={<Welcome />} />
              <Route path="/born-to-create" element={<Podcast />} />
              <Route path="/wynn" element={<Wynn />} />
              <Route path="/work-with-me" element={<WorkWithMe />} />
              <Route path="/the-deeper-reactivation" element={<TheDeeperReactivation />} />
              <Route path="*" element={<NotFound />} />
            </>
          )}
        </Routes>
        <CookieNotice />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#1A1A1A",
            border: "1px solid #E5E0D8",
            borderRadius: "2px",
            fontFamily: "Outfit, system-ui, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
